module.exports = __webpack_public_path__ + "media/images/shark/Fred-7e42e88e4e785ee2654b2cc4849623e3.jpg";